import { render } from "./CardOwnerDataPage.vue?vue&type=template&id=170cfe30&scoped=true"
import script from "./CardOwnerDataPage.vue?vue&type=script&lang=js"
export * from "./CardOwnerDataPage.vue?vue&type=script&lang=js"

import "./CardOwnerDataPage.vue?vue&type=style&index=0&id=170cfe30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170cfe30"]])

export default __exports__